module.exports = __webpack_public_path__ + "static/img/city-profile.58a713c7.jpg";